import styled from "styled-components";

export const MainTitle = styled.div`
  color: ${({ theme, emboss }) => {
    if (emboss) {
      return "#FFFFFF;";
    }
    return theme.colors.darkestgrey;
  }};
  text-shadow : ${({ emboss }) => {
    if (emboss) return "0px 3px 6px #00000077;";
    return "null;";
  }}
  font: normal normal bold 20px/22px Arkibal Sans ;
  margin-top: 10px;
`;

export const SubTitle = styled.div`
  color: ${({ theme, emboss }) => {
    if (emboss) {
      return "#FFFFFF;";
    }
    return theme.colors.darkgrey;
  }};
  font: normal normal normal 16px/20px Open Sans;
  letter-spacing: 0.74px;
  margin-top: 0px;
`;
